import {
  List,
  Datagrid,
  TextField,
  NumberField,
  EditButton,
  ShowButton,
  FunctionField,
  type RaRecord,
} from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { formatINR } from "@/utils";
import { useRouteId } from "@/utils/route-utility";
import { computeProjectTakhmeenPending } from "./project-takhmeen-display";

export const ProjectTakhmeenList = () => {
  const projectId = useRouteId();
  if (!projectId) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">
          Open a project from the Projects list to manage takhmeen.
        </Typography>
      </Box>
    );
  }
  return (
    <List perPage={25} sort={{ field: "updatedAt", order: "DESC" }} filter={{ projectId }}>
      <Datagrid rowClick="show">
        <TextField source="itsNo" label="ITS" />
        <TextField source="memberName" emptyText="—" />
        <NumberField source="units" />
        <NumberField source="committedAmount" options={{ style: "currency", currency: "INR" }} />
        <NumberField source="paidAmount" options={{ style: "currency", currency: "INR" }} />
        <FunctionField
          label="Pending"
          textAlign="right"
          render={(record: RaRecord) =>
            formatINR(computeProjectTakhmeenPending(record), { empty: "—" })
          }
        />
        <FunctionField
          label="Override"
          render={(record: RaRecord) => (record.isAmountOverridden ? "Yes" : "—")}
        />
        <DisplayDateField source="updatedAt" showTime />
        <ShowButton />
        <EditButton />
      </Datagrid>
    </List>
  );
};
